
export const surveyFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Answer__c: 'answer',
  Name: 'name',
  SurveyState__c: 'surveyState',
  CreatedDate: 'createdData',
  LastModifiedDate: {
    key: 'modifiedDate',
    in: (survey) =>
      survey.Last_Modified_By_User_Date__c ?? survey.LastModifiedDate
  },
  Answer_RTF__c: 'answerRTF',
  Template_Snapshot__c: 'templateSnapshot',
  Template__c: 'templateId',
  User__c: 'user',
  Account__c: 'account',
  OwnerId: 'owner',
  Owner_Info__c: 'ownerInfo',
  Locked__c: 'locked',
  Opportunity__c: 'opportunity',
  Account_Name__c: 'accountName',
  Contains_Aggregated_Data__c: 'containsAggragatedData'
}

export interface Survey {
  id: string
  answer: string
  name: string
  surveyState: string
  createdData: string
  modifiedDate: string
  answerRTF: string
  templateSnapshot: string
  templateId: string
  user: string
  account: string
  owner: string
  ownerInfo: string
  locked: boolean
  opportunity: string
  accountName: string
  containsAggragatedData: boolean
}
